import { Suspense } from "react"
import { ArrowLeft } from "react-feather"
import { useNavigate, useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { ReactErrorBoundary } from "@/components/ui/error-boundary"
import { SectionLoading } from "@/components/ui/loading"
import { OwnerDetailContent } from "./components/OwnerDetailContent"

export const OwnerDetailPage = () => {
  const { ownerId } = useParams<{ ownerId: string }>()
  const navigate = useNavigate()

  return (
    <div className="space-y-6">
      {/* Header - 戻るボタン */}
      <div className="flex items-center gap-2.5">
        <Button
          variant="ghost"
          size="icon"
          className="w-7 h-7 shadow-sm"
          onClick={() => navigate("/owners")}
        >
          <ArrowLeft size={14} />
        </Button>
        <h2 className="text-sm font-semibold text-slate-600">オーナー一覧に戻る</h2>
      </div>

      {/* Main Content */}
      <ReactErrorBoundary>
        <Suspense fallback={<SectionLoading />}>
          <OwnerDetailContent ownerId={ownerId ?? ""} />
        </Suspense>
      </ReactErrorBoundary>
    </div>
  )
}
